import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'src/environments/environment';
import { BoardMember } from 'src/app/models/board-members/board-member.model';
import { ApiMethod } from 'src/app/decorators/api-method.decorator';

@Injectable({
	providedIn: 'root'
})
export class BoardService {

	private baseBoardUrl = `${environment.baseUrl}/boardmember`;

	constructor(private httpClient: HttpClient) { }

	@ApiMethod()
	getContacts(token: string): Observable<BoardMember[]> {
		return this.httpClient.get<BoardMember[]>(`${this.baseBoardUrl}/${token}`);
	}
}
